import getData from "@/__main__/get-data.mjs";
import noopModel from "@/data-models/no-op.mjs";
import { getIsEmailTaken } from "@/feature-auth/fetches/api.mjs";
import getBearerToken from "@/feature-auth/utils/get-auth-request-header.mjs";
import { devError } from "@/util/dev.mjs";

export async function isEmailTaken(email) {
  let bearerToken, error;

  try {
    bearerToken = await getBearerToken();

    if (!bearerToken) {
      devError("FAILED TO QUERY EMAIL - no bearer token!", error);
      return;
    }

    const result = await getData(getIsEmailTaken(email), noopModel, undefined, {
      headers: { Authorization: bearerToken },
    });

    return result.data.isEmailTaken;
  } catch (e) {
    devError("FAILED TO QUERY EMAIL", e);
  }
}
